import { isNil } from 'lodash'

// The armed "select here" cue is painted by a pseudo-element on each
// commentable block. A block can be far taller than the panel showing it — a
// prompt runs to thousands of pixels — so anchoring the cue to the top of the
// block means it is almost never on screen. These keep it on the line the
// reader is actually looking at.

// Roughly one line of text; the cue is one line tall, and this keeps it from
// hanging off the bottom edge of a block scrolled nearly past.
const CUE_HEIGHT_PX = 22
const GUTTER_PX = 4

const isScrollable = (el) => {
  const { overflowY } = getComputedStyle(el)
  return overflowY === 'auto' || overflowY === 'scroll'
}

// The nearest ancestor that actually scrolls, which is the box the reader sees
// the block through. Null when nothing between here and the document scrolls,
// in which case the viewport is that box.
export const findScrollParent = (node) => {
  let el = node?.parentElement
  while (el && el !== document.body) {
    if (isScrollable(el)) {
      return el
    }
    el = el.parentElement
  }
  return null
}

// Offset the cue down to wherever `element` is currently scrolled, clamped so
// it stays inside the block.
export const placeArmedCue = (element, scroller) => {
  if (isNil(element)) {
    return
  }
  const bounds = scroller
    ? scroller.getBoundingClientRect()
    : { top: 0, bottom: window.innerHeight }
  const rect = element.getBoundingClientRect()
  const hidden = bounds.top - rect.top
  const room = Math.max(rect.height - CUE_HEIGHT_PX, 0)
  const offset = Math.min(Math.max(hidden, 0), room)
  element.style.setProperty('--comment-armed-top', `${Math.round(offset) + GUTTER_PX}px`)
}
